var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "changepassword"
  }, [_c('div', {
    staticClass: "col-lg-7",
    staticStyle: {
      "margin-left": "20%"
    }
  }, [_c('b-card', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-card', [_c('fieldset', [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Old Password")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-lock'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|passValue'),
      expression: "'required|passValue'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('oldPassword')
    },
    attrs: {
      "type": "password",
      "placeholder": "Enter old password",
      "name": "oldpassword",
      "id": "oldpassword"
    },
    model: {
      value: (_vm.oldpassword),
      callback: function($$v) {
        _vm.oldpassword = $$v
      },
      expression: "oldpassword"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('oldpassword')),
      expression: "errors.has('oldpassword')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Old Password field is required.")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("New Password")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-lock'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|verifypassword|verify_OldandNewPassword'),
      expression: "'required|verifypassword|verify_OldandNewPassword'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('newpassword')
    },
    attrs: {
      "type": "password",
      "maxlength": 16,
      "pattern": "(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,}",
      "title": "Must contain at least one number and one uppercase and lowercase letter, and at least 8 or more characters",
      "placeholder": "Enter new password",
      "name": "newpassword",
      "id": "newpassword"
    },
    model: {
      value: (_vm.newpassword),
      callback: function($$v) {
        _vm.newpassword = $$v
      },
      expression: "newpassword"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('newpassword')),
      expression: "errors.has('newpassword')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('newpassword')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Confirm Password")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-lock'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:newpassword|verify_OldandNewPassword'),
      expression: "'required|confirmed:newpassword|verify_OldandNewPassword'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('confirmpassword')
    },
    attrs: {
      "type": "password",
      "maxlength": 16,
      "placeholder": "Enter confirm password",
      "name": "confirmpassword",
      "id": "confirmpassword"
    },
    model: {
      value: (_vm.confirmpassword),
      callback: function($$v) {
        _vm.confirmpassword = $$v
      },
      expression: "confirmpassword"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('confirmpassword')),
      expression: "errors.has('confirmpassword')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('confirmpassword')))]), _vm._v(" \n                  ")], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "rolefooter form-actions"
  }, [_c('b-button', {
    staticClass: "glass",
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('b-button', {
    staticClass: "glasssec",
    attrs: {
      "type": "reset",
      "size": "sm"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("Cancel")])], 1)])])], 1)])])])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7adfec7d","hasScoped":true}!./src/views/components/changepassword/changepassword.component.html
// module id = 811
// module chunks = 1